import React, { useState } from "react";
import { AnimatedTick, Button, Logo, ViewBooking } from "../../../../../../Components";
import { useNavigate } from "react-router-dom";

function Success({ booking = {} }) {
	const NAVIGATE = useNavigate();
	const [BookingId, setBookingId] = useState();

	return (
		<div className="w-full h-full flex-center bg-light">
			<div className="w-full max-w-md p-6 sm:p-8 border shadow-sm bg-canvas rounded-xl">
				<div className="flex justify-center mb-2">
					<Logo short />
				</div>
				<div className="text-[11px] font-semibold tracking-wide text-center uppercase text-secondary">Travelwings for Business</div>
				<div className="h-20 flex-center">
					<AnimatedTick />
				</div>
				<div className="mt-4 text-center">
					<h1>Booking Confirmed</h1>
					<div className="mt-4 text-label">
						Your booking has been done successfully.<br/>
						You can view your booking details by clicking the View Booking button below.
					</div>
					<div className="grid grid-cols-1 gap-3 mt-8 sm:grid-cols-2">
						<Button onClick={() => setBookingId(booking.bookingId)} variant="primary" className="w-full">
							View Booking
						</Button>
						<Button onClick={() => NAVIGATE("/app/home")} variant="outlined" className="w-full">
							Go Home
						</Button>
					</div>
					<ViewBooking id={BookingId} type="flight" onClose={() => setBookingId()} />
				</div>
			</div>
		</div>
	);
}

export default Success;
